module.exports = __webpack_public_path__ + "static/media/cc-chip.7f781a96.png";